import { render, staticRenderFns } from "./index.vue?vue&type=template&id=63ad21a2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=63ad21a2&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=63ad21a2&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ad21a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ad21a2')) {
      api.createRecord('63ad21a2', component.options)
    } else {
      api.reload('63ad21a2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=63ad21a2&scoped=true", function () {
      api.rerender('63ad21a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/dashboard/index.vue"
export default component.exports